import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import './deletePage.css';
import { deletePage } from './../../../../redux/actions/entities/pages';
import { GetActivePage } from './../../../../redux/helpers/';
import { disableDeletePageRules } from './../../../../helpers/deletePage';
import { generateButtonTexts } from '../../../../helpers/weddingHelper';


class DeletePage extends Component {
  constructor(args) {
    super(args);
    this.deletePage = this.deletePage.bind(this);
  }

  deletePage() {
    const { lang, pages } = this.props;
    const { allIds, byId } = pages;
    const activePage = GetActivePage(byId);

    if (disableDeletePageRules(activePage, allIds)) {
      const alertConfig = {
        title: lang.delete_page,
        type: 'warning',
        confirmButtonText: lang.yes,
        cancelButtonText: lang.cancel,
      };

      swal({
        title: alertConfig.title,
        type: alertConfig.type,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: alertConfig.confirmButtonText,
        cancelButtonText: alertConfig.cancelButtonText,
      }).then((result) => {
        if (result.value) {
          this.props.dispatch(deletePage(activePage.id));

          swal(
            lang.deleted,
            '',
            'success',
          );
        }
      });
    }
  }

  render() {
    const {
      pages,
      lang,
      type,
    } = this.props;
    const { allIds, byId } = pages;
    const activePage = GetActivePage(byId);

    return (
      <div>
        <button className={`delete-page green-btn ${!disableDeletePageRules(activePage, allIds) ? 'not-allowed' : ''}`} onClick={this.deletePage}>
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16">
            <path d="M10,2V1A1,1,0,0,0,9,0H4A1,1,0,0,0,3,1V2H0V3H1V14a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2V3h1V2ZM4,1H9V2H4ZM4,14H3V4H4Zm3,0H6V4H7Zm3,0H9V4h1Z" />
          </svg>
          { generateButtonTexts(type, lang).delete }
        </button>
      </div>
    );
  }
}

DeletePage.defaultProps = {
  lang: {},
  pages: {},
  dispatch: () => {},
};

DeletePage.propTypes = {
  lang: PropTypes.object,
  pages: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect(state => ({
  layout: state.entities.layouts.allIds,
}))(DeletePage);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/delete-page/deletePage.jsx